import { render, staticRenderFns } from "./HospitalBilling.vue?vue&type=template&id=1b500cdc"
import script from "./HospitalBilling.vue?vue&type=script&lang=js"
export * from "./HospitalBilling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports